import { ASSETS_GROUPS } from '@/entities/account';
import type { TradingAssetRow } from './types';

export const defaultRowsComparator = (
  a: TradingAssetRow,
  b: TradingAssetRow
): number => {
  const aIsFiat = a.group === ASSETS_GROUPS.fiat;
  const bIsFiat = b.group === ASSETS_GROUPS.fiat;

  if (aIsFiat !== bIsFiat) {
    return aIsFiat ? -1 : 1;
  }

  return b.baseAmount - a.baseAmount;
};
